const middleware = {}

middleware['auth-order'] = require('../middleware/auth-order.ts')
middleware['auth-order'] = middleware['auth-order'].default || middleware['auth-order']

middleware['docs-redirect'] = require('../middleware/docs-redirect.ts')
middleware['docs-redirect'] = middleware['docs-redirect'].default || middleware['docs-redirect']

export default middleware
